"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["downloadQrCode"] = "downloadQrCode";
  TranslationKey["generateQrCode"] = "generateQrCode";
  TranslationKey["qrCodeOptionWithScanMeLabelOnBottom"] = "qrCodeOptionWithScanMeLabelOnBottom";
  TranslationKey["qrCodeOptionWithScanMeLabelOnTop"] = "qrCodeOptionWithScanMeLabelOnTop";
  TranslationKey["qrCodeOptionWithoutScanMeLabel"] = "qrCodeOptionWithoutScanMeLabel";
  TranslationKey["scanMe"] = "scanMe";
  return TranslationKey;
}({});
